import OfferDetails from './OfferDetails';

export default OfferDetails;